import { createReducer, on } from '@ngrx/store';
import * as ProjectActions from '../actions/projects.actions';

export interface State {
  projects: any[];
  errorMessage: string | null;
  isLoading: boolean;
   createSuccess?:boolean | null;
}
export const initialState: State = {
  projects: [],
  errorMessage: null,
  isLoading: false
};
export const projectsReducer = createReducer(
  initialState,

  on(ProjectActions.loadProjects, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),

  on(ProjectActions.loadProjectsSuccess, (state, { projects }) => {
    return {
      ...state,
      projects,
      isLoading: false,
      errorMessage: null
    };
  }),
  on(ProjectActions.loadProjectsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  })),
  on(ProjectActions.createProject, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),
  on(ProjectActions.createProjectSuccess, (state, { project }) => ({
    ...state,
    projects: [...state.projects, project],
    isLoading: false,
    createSuccess: true,
    errorMessage: null
  })),
  on(ProjectActions.createProjectFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  })),
  on(ProjectActions.updateProject, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),
  on(ProjectActions.updateProjectSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.id === project.id ? project : p),
    isLoading: false,
    errorMessage: null
  })),
  on(ProjectActions.updateProjectFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  })),
  on(ProjectActions.deleteProject, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),
  on(ProjectActions.deleteProjectSuccess, (state, { projectId }) => ({
    ...state,
    projects: state.projects.filter(p => p.id !== projectId),
    isLoading: false,
    errorMessage: null
  })),
  on(ProjectActions.deleteProjectFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  }))

);